import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteDepositoGarantiaService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-depositos-garantia';
    this.service_url = this.api_url + this.modulo_url;
  }
  
  getProveedores(obra, fechaInicial, fechaFinal){
    if(obra && obra["idObras"]){
      return this.http.get(this.service_url + '/proveedores?obra=' + obra["idObras"] + '&fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '/proveedores?fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
  }

  getObras(fechaInicial, fechaFinal) {
    return this.http.get(this.service_url + '/obras?fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
  }
  
  getFechaReporte(proveedor, fecha, fechaFinal, obra) {
    if(proveedor && proveedor.idProveedores && obra && obra.idObras){
      return this.http.get(this.service_url + '/generar/fecha?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores + '&obra=' + obra.idObras , this.authService.getAuthHeaders());
    }
    if (proveedor && proveedor.idProveedores){
      return this.http.get(this.service_url + '/generar/fecha?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores, this.authService.getAuthHeaders());
    }
    if (obra && obra.idObras) {
      return this.http.get(this.service_url + '/generar/fecha?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&obra=' + obra.idObras , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '/generar/fecha?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
  }

  getFechaReporteGarantia(proveedor, fecha, fechaFinal, obra) {
    if(proveedor && proveedor.idProveedores && obra && obra.idObras){
      return this.http.get(this.api_url + '/reportes/fecha/garantia?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores + '&obra=' + obra.idObras , this.authService.getAuthHeaders());
    }
    if (proveedor && proveedor.idProveedores){
      return this.http.get(this.api_url + '/reportes/fecha/garantia?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores, this.authService.getAuthHeaders());
    }
    if (obra && obra.idObras) {
      return this.http.get(this.api_url + '/reportes/fecha/garantia?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&obra=' + obra.idObras , this.authService.getAuthHeaders());
    }
    return this.http.get(this.api_url + '/reportes/fecha/garantia?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
  }
  
  getTotales(proveedor, fecha, fechaFinal, obra) {
    if(proveedor && proveedor.idProveedores && obra && obra.idObras){
      let idObra = obra.idObras;
      return this.http.get(this.service_url + '/generar/totales?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores + '&obra=' + idObra , this.authService.getAuthHeaders());
    }
    if (proveedor && proveedor.idProveedores){
      return this.http.get(this.service_url + '/generar/totales?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores, this.authService.getAuthHeaders());
    }
    if (obra && obra.idObras) {
      return this.http.get(this.service_url + '/generar/totales?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&obra=' + obra.idObras , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '/generar/totales?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
  }

  getLista(proveedor, fecha, fechaFinal, obra, soloSaldoPendiente = false) {
    let baseUrl = this.service_url + '/generar/lista?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal;
    
    if (soloSaldoPendiente) {
      baseUrl += '&soloSaldoPendiente=1';
    }
    
    if(proveedor && proveedor.idProveedores && obra && obra.idObras){
      return this.http.get(baseUrl + '&proveedor=' + proveedor.idProveedores + '&obra=' + obra.idObras, this.authService.getAuthHeaders());
    }
    if (proveedor && proveedor.idProveedores){
      return this.http.get(baseUrl + '&proveedor=' + proveedor.idProveedores, this.authService.getAuthHeaders());
    }
    if (obra && obra.idObras) {
      return this.http.get(baseUrl + '&obra=' + obra.idObras, this.authService.getAuthHeaders());
    }
    return this.http.get(baseUrl, this.authService.getAuthHeaders());
  }

  getTabla(proveedor, fecha, fechaFinal, obra, tipo, soloSaldoPendiente = false) {
    let baseUrl = this.service_url + '/generar/tabla?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal + '&proveedor=' + proveedor.idProveedores + '&obra=' + obra.idObras + '&tipo=' + tipo;
    
    if (soloSaldoPendiente) {
      baseUrl += '&soloSaldoPendiente=1';
    }
    
    return this.http.get(baseUrl, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reporte-deposito-garantia.service.ts